import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { EVENT } from 'lib/segment/const'
import { segmentReferralTrack } from 'lib/segment'
import Typo from 'constants/typography'
import { BUTTON_TYPES } from 'constants/button'
import { AUTH_UI_STATE } from 'components/auth/const'
import authDuck from 'components/auth/duck'
import Button from 'components/common/button'
import ReferralHowToEarn from 'components/referral/landing/landing-desktop/how-to-earn'
import ReferralBanner from 'components/referral/landing/landing-desktop/banner'

const ReferralDesktopLandingGuestUser = ({ setStage, updateShowLogin, t }) => {
  const showLoginPage = () => {
    updateShowLogin(true)
    segmentReferralTrack(EVENT.referralGuestLoginClicked)
  }

  const showSignUpPage = () => {
    setStage(AUTH_UI_STATE.signUp)
    updateShowLogin(true)
    segmentReferralTrack(EVENT.referralGuestSignupClicked)
  }

  useEffect(() => segmentReferralTrack(EVENT.referralGuestViewed), [])

  return (
    <div className="referral-landing">
      <ReferralBanner>
        <Button
          className="referral-landing-banner__content-button"
          type={BUTTON_TYPES.primary}
          onClick={showLoginPage}
        >
          {t('Log in')}
        </Button>
        <div className="referral-landing-banner__content-signup">
          <span className={Typo.subtitle2}>
            {t("Don't have an account?")}
            <Button
              className="referral-landing-banner__content-signup-cta"
              type={BUTTON_TYPES.link}
              onClick={showSignUpPage}
            >
              {hasLocizeTranslation(t, 'AUTH_GO_SIGN_UP', 'Sign Up')}
            </Button>
          </span>
        </div>
      </ReferralBanner>
      <ReferralHowToEarn />
    </div>
  )
}

ReferralDesktopLandingGuestUser.propTypes = {
  setStage: PropTypes.func.isRequired,
  updateShowLogin: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(ReferralDesktopLandingGuestUser)

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      setStage: authDuck.creators.setStage,
      updateShowLogin: authDuck.creators.updateShowLogin,
    },
    dispatch,
  ),
)(Extended)
